import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('idx_list_user_tabs_unique', ['fkUserId', 'listKey'], { unique: true })
@Index('idx_list_user_tabs_user', ['fkUserId'])
@Entity('list_user_tabs')
export class ListUserTabsEntity extends BaseEntity {
	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: '_list_key', length: 100 })
	public listKey!: string;

	/**
	 * The person's tab order as last arranged. Before PD-14278 this was the
	 * literal strip, returned verbatim forever; it is now the order half of a
	 * delta over the audience-resolved strip, so tabs added later still reach
	 * people who rearranged their own.
	 */
	@Column('json', { name: '_tab_ids' })
	public tabIds!: Array<string>;

	/**
	 * PD-14278 — tabs the person hid. NULL means the row predates the delta
	 * model and `tabIds` is still a photograph; the migration fills it in.
	 */
	@Column('json', { name: 'hiddenIds', nullable: true })
	public hiddenIds!: Array<string> | null;

	@Column({ type: 'boolean', name: 'isEnabled', width: 1, default: () => "'1'" })
	public isEnabled!: boolean;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;
}
